// The homepage board's "Live Prices" view for a visitor without Premium
// (index-lock mock, 2026-10-12). The Daily Live Price table and the weekly
// grid are index prices end to end, so the whole panel is the lock — there is
// nothing price-free left to show in it.
import { lockButton } from "@/lib/indexAccess";
import { SITE_PLAN } from "@/lib/sitePlan";
import type { Access } from "@/lib/siteAccess";

import LockMark from "./LockMark";

export default function LivePricesLocked({ cta }: { cta: Access["state"] }) {
  return (
    <div className="rbtx-lplock">
      <LockMark />
      <h3>Daily Live Prices are part of {SITE_PLAN.short}</h3>
      <p>Today&rsquo;s price for every RaisedBeef Index, and the week day by day.</p>
      <a href="/membership">{lockButton(cta)}</a>
    </div>
  );
}
